module.exports = __webpack_public_path__ + "static/media/Artemisia-Lufkin.08b5b125.png";